// @ts-nocheck
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from "@mui/material/InputAdornment";
import Joi from 'joi';
import { RUTA_API_AREAS } from "../../Contantes/Constantes";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import { useBody } from "../../Body/state/BodyContext";
import { TextFieldRojo } from "../../App";
import Box from "@mui/material/Box";
import AreaInternoItem from "./AreaInternoItem";
import Typography from "@mui/material/Typography";
import { ModalGeneral } from '../../Componentes/ModalGeneral';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { VerInterno } from "./VerInterno";
import { useAreas } from '../../Areas/State/AreasContext';
import CircularProgress from "@mui/material/CircularProgress";
import CircularIndeterminate from '../../Componentes/CircularIndeterminate';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { useMediaQuery } from '@mui/material';

const schema = Joi.object({
    patron: Joi.string().alphanum().min(1).max(30).required()
});

const BuscadorInternos = () => {
    const { areasTreeFlatList, getAreasTree } = useAreas();
    const [patron, setPatron] = useState("");
    const [areas, setAreas] = React.useState([]);
    const [tipoBusqueda, setTipoBusqueda] = useState("area");
    const { setMessage, setSuccess, setInfo } = useBody();
    const [openModalVer, setOpenModalVer] = useState(false);
    const [internoVer, setInternoVer] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingScreen, setLoadingScreen] = useState(false);
    const axiosInstance = setupInterceptorsTo(axios.create());
    const matches = useMediaQuery('(min-width:1185px)');

    const isValid = (patron) => {
        const { error } = schema.validate({ patron: patron });
        return error === undefined;
    };

    async function fetchAreasTree() {
        setLoadingScreen(true);
        await getAreasTree();
        setLoadingScreen(false);
    }

    async function searchArea() {
        setLoading(true);
        await axiosInstance({
            method: 'get',
            url: RUTA_API_AREAS + "/buscar/interno/" + patron,
        })
            .then(({ data }) => {
                if (data.length === 0) {
                    setInfo("No se encontraron áreas con ese patrón.");
                } else {
                    setAreas(Object.values(data));
                }
            })
            .catch(() => {
                setMessage("Ocurrió un error al realizar la búsqueda");
            });
        setLoading(false);
    }

    const searchAutoridad = async () => {
        setLoading(true);

        setLoading(false);
    };

    useEffect(() => {
        fetchAreasTree();
    }, []);

    useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            if (isValid(patron)) {
                if (tipoBusqueda === 'area') {
                    searchArea();
                } else if (tipoBusqueda === 'autoridad') {
                    searchAutoridad();
                }
            }
        }, 800);
        return () => clearTimeout(debounceTimeout);
    }, [patron, tipoBusqueda]);

    const handleChange = (e) => {
        let patronBuscado = e.target.value;
        if (patronBuscado.length < 1) return false;
        if (!isValid(patronBuscado)) {
            e.target.error = true;
            e.target.helperText = "Alguno de los caracteres ingresados es inválido";
            setMessage("Alguno de los caracteres ingresados es inválido");
            return false;
        } else {
            e.target.error = false;
            e.target.helperText = "Ingrese el nombre.";
            setPatron(patronBuscado);
        }
    };

    const handleOpenDetails = (areaPath) => {
        const area = areasTreeFlatList.find(area => area.path === areaPath);
        setInternoVer(area);
        setOpenModalVer(true);
    }

    const onClose = () => {
        setOpenModalVer(false);
    };

    return (
        <>
            {loadingScreen ? (
                <div style={{ display: 'flex', justifyContent: 'center', marginLeft: '5%', height: '50vh', alignItems: 'center' }}>
                    <CircularIndeterminate size={100} />
                </div>
            ) : (
                <Box >
                    <Box sx={{ paddingX: { xs: '20px', md: "40px" } }}>
                        <Typography
                            my={"40px"}
                            fontSize={matches ? "30px" : "28px"}
                        >
                            Buscador de Internos
                        </Typography>
                        <Box display="flex" alignItems="center" width="100%" marginY={2} gap={2}>
                            <TextFieldRojo
                                id="buscador"
                                label={tipoBusqueda === 'area' ? "Nombre del Área" : "Nombre de la Autoridad"}
                                onChange={handleChange}
                                variant="outlined"
                                fullWidth
                                helperText={
                                    tipoBusqueda === 'area'
                                        ? "Ingrese el nombre del área que le interesa saber su interno."
                                        : "Ingrese el nombre de la autoridad para buscar sus internos."
                                }
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {/* Futura implementacion para buscar por autoridad 

                        <FormControl sx={{ minWidth: 160, marginTop: "-25px" }}>
                            <InputLabel id="tipo-busqueda-label">Buscar por</InputLabel>
                            <Select 
                                labelId="tipo-busqueda-label"
                                id="tipo-busqueda"
                                value={tipoBusqueda}
                                label="Buscar por"
                                onChange={(e) => setTipoBusqueda(e.target.value)}
                            >
                                <MenuItem value="area">Área</MenuItem>
                                <MenuItem value="autoridad">Autoridad</MenuItem>
                            </Select>
                        </FormControl>
                        */}
                        </Box>
                    </Box>
                    {loading && (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "15px" }}>
                            <CircularProgress />
                            <Typography
                                sx={{
                                    fontWeight: "100",
                                    marginLeft: "20px",
                                    fontSize: {
                                        xs: '17px',
                                        lg: '18px',
                                    }
                                }}
                            >
                                Obteniendo Resultados...
                            </Typography>
                        </div>
                    )}

                    <List>
                        {areas.length !== 0 ? areas.map((area, index) => (
                            <React.Fragment key={index}>
                                <div style={{ borderRadius: "30px" }} >
                                    <ListItem sx={{ borderRadius: '30px', width: '100%', paddingX: { xs: '20px', md: "40px" } }} alignItems="flex-start">
                                        <AreaInternoItem nombre={area.nombre} areaPath={area.path} internos={area.internos} handleOpenDetails={handleOpenDetails} />
                                    </ListItem>
                                </div>
                                <br />
                            </React.Fragment>
                        )) : null}
                    </List>
                </Box>
            )}

            <ModalGeneral
                Contenido={<VerInterno area={internoVer} />}
                titulo={internoVer.name}
                open={openModalVer}
                onClose={onClose}
            />
        </>
    );
}

export default BuscadorInternos;
